import {
  Button,
  Chip,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { BuildingGuestParking } from "../../../graphql/models";
import { useEffect, useState } from "react";
import { BuildingGuestParkingCamera } from "./building_guest_parking_camera";

export interface BuildingGuestParkingComponentProps {
  value: BuildingGuestParking;
  onChange: (newValue: BuildingGuestParking) => void;
}

export function BuildingGuestParkingComponent(
  props: BuildingGuestParkingComponentProps
) {
  const v = props.value;
  //const [codes, setCodes] = useState(v?.parkingCodes ?? []);
  const [parkingCodes, setParkingCodes] = useState(
    v?.parkingCodes
      ? v.parkingCodes.map((item, index) => {
          const value: ParkingCodeUISlotModel = {
            code: item,
            order: (index + 1) * 10,
          };
          return value;
        })
      : []
  );
  const [devices, setDevices] = useState(v.devices ?? []);

  const numOfBoxes = parkingCodes.length;
  const orderValues = parkingCodes.map((item) => item.order);
  const maxOrderValue = orderValues.length === 0 ? 0 : Math.max(...orderValues);

  parkingCodes.forEach((item, index) => {
    if (!item.code) {
      item.hasError = true;
      item.errorMessage = "Inserire un valore nel campo Codice";
    } else {
      const duplIndex = parkingCodes.findIndex(
        (item2, index2) => index2 !== index && item2.code === item.code
      );
      if (duplIndex === -1) {
        item.hasError = false;
        item.errorMessage = "";
      } else {
        item.hasError = true;
        item.errorMessage = "Codice duplicato!";
      }
    }
  });

  const addCode = () => {
    setParkingCodes([
      ...parkingCodes,
      {
        code: "",
        order: maxOrderValue + 10,
      },
    ]);
  };

  const removeCode = (index: number) => {
    const newArray = [...parkingCodes];
    newArray.splice(index, 1);
    setParkingCodes(newArray);
  };

  useEffect(() => {
    const arrayCopy = [...parkingCodes];
    props.onChange({
      parkingCodes: arrayCopy
        .sort((a, b) => a.order - b.order)
        .map((item) => item.code),
      devices: [...devices],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parkingCodes, devices]);

  return (
    <Paper>
      <Grid item xs={12}>
        <Typography variant="h4" style={{ textAlign: "center" }}>
          Guest Parking
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ padding: "1rem" }}>
        <fieldset style={{ borderRadius: "1rem" }}>
          <legend>Sezione Parcheggi</legend>
          <Grid item xs={12} md={2}>
            <TextField
              label="Parcheggi disponibili"
              value={numOfBoxes}
              disabled={true}
              variant="outlined"
              style={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              variant="outlined"
              onClick={addCode}
              style={{ margin: "10px 0" }}
            >
              Aggiungi
            </Button>
          </Grid>
          <Grid item xs={12}>
            <BuildingGuestParkingSlot
              rows={parkingCodes}
              onDeleteItem={(index) => removeCode(index)}
              onChange={setParkingCodes}
            ></BuildingGuestParkingSlot>
          </Grid>
        </fieldset>
      </Grid>

      <Grid item xs={12} style={{ padding: "1rem" }}>
        <BuildingGuestParkingCamera
          devices={devices}
          onChange={setDevices}
        ></BuildingGuestParkingCamera>
      </Grid>
    </Paper>
  );
}

export interface ParkingCodeUISlotModel {
  order: number;
  code: String;
  hasError?: boolean;
  errorMessage?: string;
}

export interface BuildingGuestParkingSlotProps {
  onDeleteItem: (index: number) => void;
  onChange: (items: ParkingCodeUISlotModel[]) => void;
  rows: ParkingCodeUISlotModel[];
}

export function BuildingGuestParkingSlot(props: BuildingGuestParkingSlotProps) {
  const { rows } = props;

  const onChangeCode = (value: String, index: number) => {
    const newArray = [...rows];
    newArray[index].code = value;
    props.onChange(newArray);
  };

  const onChangeOrder = (value: string, index: number) => {
    const order = Number.parseInt(value);
    if (Number.isNaN(order)) return;
    const newArray = [...rows];
    newArray[index].order = order;
    props.onChange(newArray);
  };

  return (
    <table cellPadding={1} cellSpacing={2}>
      <tr>
        <th>Codice Parcheggio</th>
        <th>Ordine</th>
        <th></th>
        <th>Errore?</th>
      </tr>
      {rows.length > 0 &&
        rows.map((row, index) => (
          <tr key={`row_${index}`}>
            <td>
              <TextField
                variant="outlined"
                value={row.code}
                onChange={(e) => onChangeCode(e.target.value, index)}
                style={{ width: "100%" }}
              ></TextField>
            </td>
            <td>
              <TextField
                variant="outlined"
                type="number"
                value={row.order}
                onChange={(e) => onChangeOrder(e.target.value, index)}
                style={{ width: "100%" }}
              ></TextField>
            </td>
            <td>
              <Button
                variant="outlined"
                type="button"
                onClick={() => props.onDeleteItem(index)}
              >
                Elimina
              </Button>
            </td>
            <td>
              {row.hasError && (
                <Chip
                  label={row.errorMessage}
                  variant="outlined"
                  style={{ backgroundColor: "darkred" }}
                />
              )}
            </td>
          </tr>
        ))}
      {rows.length === 0 && (
        <tr>
          <td colSpan={4}>Nessun codice parcheggio inserito!</td>
        </tr>
      )}
    </table>
  );
}
